export default __webpack_public_path__ + "static/media/secondChild.ae86be1d.svg";